import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import g1 from "@/assets/Akram.jpeg";
import g2 from "@/assets/Ridhwaan.jpeg";
import g3 from "@/assets/GranBaie.jpeg";
import g4 from "@/assets/Wazam.jpeg";
import g5 from "@/assets/Ochatoya.jpeg";

const items = [
  { src: g1, label: "Residential rooftop array", tag: "Solar" },
  { src: g4, label: "Residential rooftop array", tag: "Solar" },
  { src: g2, label: "Residential rooftop array", tag: "Solar" },
  { src: g3, label: "Residential rooftop array", tag: "Solar" },
  { src: g5, label: "Residential rooftop array", tag: "Solar" },
];

export function Gallery() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="gallery" className="py-24 sm:py-32 relative bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div className="max-w-2xl">
            <span className="text-sm font-medium text-primary uppercase tracking-widest">
              Installations
            </span>
            <h2 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight">
              Real work, real results.
            </h2>
          </div>
          <p className="text-muted-foreground max-w-md">
            A selection of recent solar and electrical projects across the island.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 auto-rows-[200px] gap-3 sm:gap-4">
          {items.map((it, i) => (
            <motion.button
              key={i}
              type="button"
              onClick={() => setOpen(i)}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className={`group relative overflow-hidden rounded-2xl bg-card ${
                i === 0 ? "col-span-2 row-span-2" : i === 3 ? "lg:col-span-2" : ""
              }`}
            >
              <img
                src={it.src}
                alt={it.label}
                loading="lazy"
                width={1024}
                height={1024}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-linear-to-t from-black/80 via-black/0 to-transparent opacity-90 group-hover:opacity-100 transition" />
              <div className="absolute bottom-3 left-3 right-3 text-left">
                <span className="inline-block px-2 py-0.5 rounded-md bg-primary/90 text-primary-foreground text-[10px] font-medium uppercase tracking-wider">
                  {it.tag}
                </span>
                <div className="mt-1.5 text-white text-sm font-medium">{it.label}</div>
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {open !== null && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setOpen(null)}
            className="fixed inset-0 z-100 bg-black/90 backdrop-blur-md grid place-items-center p-4"
          >
            <button
              onClick={() => setOpen(null)}
              className="absolute top-4 right-4 grid place-items-center w-10 h-10 rounded-full bg-white/10 text-white hover:bg-white/20"
              aria-label="Close"
            >
              <X className="w-5 h-5" />
            </button>
            <motion.img
              initial={{ scale: 0.95 }}
              animate={{ scale: 1 }}
              src={items[open].src}
              alt={items[open].label}
              className="max-w-[95vw] max-h-[88vh] rounded-2xl shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
